import { Component, computed, input } from '@angular/core'
import { TooltipModule } from '@ftr/foundation'
import { CartTime } from '../../../store'
import { formatCartTime } from '../../../utils'

@Component({
  selector: 'ftr-cart-times-display',
  templateUrl: './cart-times-display.component.html',
  styleUrl: './cart-times-display.component.css',
  imports: [TooltipModule],
})
export class CartTimesDisplayComponent {
  readonly requestedTimes = input.required<CartTime[]>()
  readonly maxVisible = input<number, number>(undefined, {
    transform: value => (value !== undefined ? Math.max(1, value) : undefined),
  })
  readonly isStacked = input<boolean>(false)

  protected readonly splitTimes = computed<{ visible: string[]; truncated: string[] }>(() => {
    const times = this.requestedTimes()

    if (!times.length) return { visible: [], truncated: [] }

    const maxVisible = this.maxVisible()
    const formattedTimes = times.map(formatCartTime)

    if (!maxVisible) return { visible: formattedTimes, truncated: [] }

    const visible = formattedTimes.slice(0, maxVisible)
    const truncated = formattedTimes.slice(maxVisible)

    return { visible, truncated }
  })
}
